import type { WordDocumentGateway } from "../types/contracts";

import { log } from "./logger";

export class OfficeWordGateway implements WordDocumentGateway {
  async readBodyHtml(): Promise<string> {
    log("debug", "word.readBodyHtml.start");
    return Word.run(async (context: Word.RequestContext) => {
      const html = context.document.body.getHtml();
      await context.sync();
      log("info", "word.readBodyHtml.success", { htmlChars: html.value.length });
      return html.value;
    });
  }

  async replaceBodyFromHtml(html: string): Promise<void> {
    log("debug", "word.replaceBodyFromHtml.start", { htmlChars: html.length });
    await Word.run(async (context: Word.RequestContext) => {
      context.document.body.clear();
      context.document.body.insertHtml(html, Word.InsertLocation.replace);
      await context.sync();
      log("info", "word.replaceBodyFromHtml.success", { htmlChars: html.length });
    });
  }
}
